import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Do I get the full prompts or just ideas?',
  a: 'The full prompts. All 120 are complete and ready to copy and paste. You only fill in the [brackets] with your own clinical information.'
}, {
  q: 'What about client privacy and HIPAA?',
  a: 'Every clinical prompt is written to work with de-identified information: initials or “Client A”, an age range and roles, never names, dates of birth or insurance IDs. The toolkit includes a privacy checklist and reminds you to follow HIPAA or your local privacy law and to use the AI tool your practice approves. You add identifiers only in your EHR.'
}, {
  q: 'Will the AI diagnose or make clinical decisions?',
  a: 'No. The prompts are written so the AI never diagnoses, decides risk, chooses codes or decides medical necessity. You enter your clinical decisions; the AI organizes and drafts. You always review and sign.'
}, {
  q: 'Will the AI make things up?',
  a: 'Every prompt tells the AI to use only the information you give it and to ask you when something is missing.'
}, {
  q: 'Which note formats are included?',
  a: 'SOAP, DAP, BIRP, GIRP and PIE notes, plus intake summaries, telehealth, couples, family and group notes, discharge summaries and more.'
}, {
  q: 'Does it work outside the US?',
  a: 'Yes. It is written for clinicians in the US, Canada, the UK, Australia and New Zealand, and you can tell the AI your spelling, your terms and your local requirements.'
}, {
  q: 'Do I need to be a tech expert?',
  a: 'No. If you can copy and paste, you can use this toolkit on your phone, tablet or computer.'
}, {
  q: 'Is it a one-time payment?',
  a: 'Yes. Pay once and keep the PDF. No subscription.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-38" data-mp="iz69xo5kfzve">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-39" data-mp="myojxovumqjg">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-40" data-mp="2pnya60to3btd">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-41" data-mp="2fwan0c458gxp">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-42" data-mp="38l98nj7h617r" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-43" data-mp="38k6ft5qldop7">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-44" data-mp="2ukon4fa6drak">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-blush" data-id="element-45" data-mp="1n97o3ivk246x" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-46" data-mp="1j6kt593l835i" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-47" data-mp="1j8xhq53upbrj">
                  <div className="overflow-hidden" data-id="element-48" data-mp="2qdoyf3yzztu">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-49" data-mp="7oox8lema29y">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}